import React, { CSSProperties, FC, memo } from "react";
import ReactHtmlParser from "react-html-parser";
import { useDrag } from "react-dnd";

const style: CSSProperties = {
  cursor: "move",
};

const disabledStyle: CSSProperties = {
  border: "1px solid gray",
  backgroundColor: "white",
  padding: "0.5rem 2rem",
  marginRight: "1.5rem",
  float: "left",
};

export interface RandomMatrixSortItemProps {
  answer: any;
  disabled: boolean;
}

export const ItemTypes = {
  BOX: "box",
};

export const RandomMatrixSortItem: FC<RandomMatrixSortItemProps> = memo(
  function RandomMatrixSortItem({ answer, disabled }) {
    const [{ opacity }, drag] = useDrag(
      () => ({
        type: ItemTypes.BOX,
        item: answer,
        collect: (monitor) => ({
          opacity: monitor.isDragging() ? 0.4 : 1,
        }),
      }),
      [answer]
    );

    return disabled ? (
      <div role="Box" style={disabledStyle} className="drag_box">
        <div style={{overflow: "hidden"}}>
          {ReactHtmlParser(
            answer._id % 2 === 0 ? answer._sortString : answer._answer
          )} 
        </div>
        <span className="drag_placeholder left_side"></span>
        <span className="drag_placeholder right_side"></span>
      </div>
    ) : (
      <div ref={drag} role="Box" style={{ ...style, opacity }} className="drag_box">
        <div style={{ overflow: "hidden"}}>
          {ReactHtmlParser(
            answer._id % 2 === 0 ? answer._sortString : answer._answer
          )}
        </div>
        <span className="drag_placeholder left_side"></span>
        <span className="drag_placeholder right_side"></span>
      </div>
    );
  }
);
